import { HEADER_NAV_SIGNUP_CTA_COPY_120224 } from "@faire/web-api--source/indigofair/settings/HEADER_NAV_SIGNUP_CTA_COPY_120224";
import { IFiveVariantXP } from "@faire/web-api--source/indigofair/settings/IFiveVariantXP";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingHeaderNavSignupCTACopy = () => {
  return useSetting(
    HEADER_NAV_SIGNUP_CTA_COPY_120224,
    IFiveVariantXP.Bucket.CONTROL
  );
};

export const useAssignSettingHeaderNavSignupCTACopy = () => {
  return useAssignSetting(HEADER_NAV_SIGNUP_CTA_COPY_120224);
};
